import { GridColumnHeaderParams } from "@mui/x-data-grid";
import { FilterItem } from "../Modals/CertConnectCustomFilterModal";
import { FilterAlt } from "@mui/icons-material";

const HeaderWithFilterIcon = ({
  params,
  filters,
  name
}: {
  params: GridColumnHeaderParams;
  filters: FilterItem[];
  name: string
}) => {
  const field = params.field;
  const hasFilter = filters.some(f => f.field === field && f.value !== "" && f.value !== null);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4, fontWeight: 500 }}>
      <span>{name}</span> 
      {hasFilter && <FilterAlt fontSize="small" sx={{ color: "#FFFF" }} />}
    </div>
  );
};

export default HeaderWithFilterIcon;